'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const EmptyStateActions = renderWithRef('EmptyStateActions', null, (e, r)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        classNames: [
            'swan-empty-state-actions'
        ],
        props: e,
        children: e.children
    }));

export { EmptyStateActions };
